// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"19d589ab","832":"6e3f4ed7"}[chunkId] + ".chunk.js";
};